const conceptualLabelSelectors = {
    editingConceptualLabelId: state => state.conceptualLabel.editingConceptualLabelId,
    showCreateConceptualLabelDrawer: state => state.conceptualLabel.showCreateConceptualLabelDrawer,
    createFormInitialValues: state => state.conceptualLabel.createFormInitialValues,
}

export default conceptualLabelSelectors
